import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, RedirectCommand, Router } from '@angular/router';
import { PermissionService } from './permission.service';
import { PermissionInput } from './permission.model';

type Req = PermissionInput | PermissionInput[] | undefined;

function permitido(req: Req, perm: PermissionService): boolean {
    if (!req) return true;
    return Array.isArray(req) ? perm.canAny(req) : perm.can(req);
}

/**
 * Renderiza `SemAcesso` sem trocar a barra de endereços (`skipLocationChange`), de modo que a URL
 * digitada permanece visível e o componente real nunca é instanciado (nada de 403 em rajada).
 * Exportada para reuso por guards que resolvem um destino dinâmico e caem em Sem acesso quando
 * nenhuma opção é alcançável (ex.: `arrecadacaoDashboardLandingGuard`).
 */
export function negar(router: Router): RedirectCommand {
    return new RedirectCommand(router.parseUrl('/sem-acesso'), { skipLocationChange: true });
}

export const permissionGuard: CanActivateFn = (route) => {
    const perm = inject(PermissionService);
    const router = inject(Router);
    const req = route.data?.['permission'] as Req;
    return permitido(req, perm) ? true : negar(router);
};

export const permissionMatchGuard: CanMatchFn = (route) => {
    const perm = inject(PermissionService);
    const router = inject(Router);
    const req = route.data?.['permission'] as Req;
    return permitido(req, perm) ? true : negar(router);
};
